// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ../views/modules/simplified-events-block/assets/scss/simplified-events-block.scss
// module id = 127
// module chunks = 19